import React from "react";
import "./newUser.css";
import { Collapse, Checkbox, Col } from "antd";
import { useSelector } from "react-redux";

const { Panel } = Collapse;

export default function Permission({
    view,
    permissoes,
    handleChange,
    handleSelecionarTodosGeral,
    selecionarTodosGeral,
}) {
    const user = useSelector(state => state.user);

    const groupsCreate = [
        { key: "client", label: "Cliente" },
        { key: "user", label: "Usuário" },
        { key: "driver", label: "Motorista" },
        { key: "shipper", label: "Embarcador" },
        { key: "freight", label: "Frete" },
    ];

    const groupsFiscal = [
        { key: "mdfe", label: "MDF-E" },
        { key: "import", label: "Importação" },
    ];

    const groupsPayment = [
        { key: "payment", label: "Pagamento" },
    ];

    const groupsParameters = [
        { key: "tableIcms", label: "Tabela ICMS" },
        { key: "ocurrence", label: "Ocorrências" },
        { key: "tablePrice", label: "Tabela de Preço" },
        { key: "perfil", label: "Perfil" },
    ];

    const groupsAcomp = [
        { key: "accompaniment", label: "Acompanhamento" },
    ]

    const renderCell = (groupKey, fieldKey) => {
        const checked = !!permissoes?.[groupKey]?.[fieldKey];
        return (
            <td style={{ textAlign: "center", padding: "6px 8px" }}>
                <input
                    disabled={view}
                    type="checkbox"
                    checked={checked}
                    onChange={() => handleChange(groupKey, fieldKey)}
                />
            </td>
        );
    };

    return (
        <div style={{ width: "100%", overflowX: "auto" }}>
            <div style={{ marginBottom: 8 }}>
                <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <input
                        disabled={view}
                        type="checkbox"
                        name="selecionarTodos"
                        checked={selecionarTodosGeral || false}
                        onChange={handleSelecionarTodosGeral}
                    />
                    <span>Selecionar Todos</span>
                </label>
            </div>

            <Collapse accordion className="collapse-full" >
                <Panel header={"Cadastros"} key={"permissoes"}>
                    <table className="permission-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ background: "#f5f5f5" }}>
                                <th style={{ textAlign: "left", padding: "8px 12px" }}></th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Selecionar Todos</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Visualizar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Cadastrar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Editar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Excluir</th>
                            </tr>
                        </thead>
                        <tbody>
                            {groupsCreate.map((g) => (
                                <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                    <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                    {renderCell(g.key, "selecionarTodos")}
                                    {renderCell(g.key, "isView")}
                                    {renderCell(g.key, "isCreate")}
                                    {renderCell(g.key, "isEdit")}
                                    {renderCell(g.key, "isDelete")}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Panel>
            </Collapse>

            <Collapse accordion className="collapse-full" >
                <Panel header={"Fiscal"} key={"permissoes-repetido"}>
                    <table className="permission-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ background: "#f5f5f5" }}>
                                <th style={{ textAlign: "left", padding: "8px 12px" }}></th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Selecionar Todos</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Visualizar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Cadastrar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Editar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Excluir</th>
                            </tr>
                        </thead>
                        <tbody>
                            {groupsFiscal.map((g) => (
                                <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                    <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                    {renderCell(g.key, "selecionarTodos")}
                                    {renderCell(g.key, "isView")}
                                    {renderCell(g.key, "isCreate")}
                                    {renderCell(g.key, "isEdit")}
                                    {renderCell(g.key, "isDelete")}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Panel>
            </Collapse>

            <Collapse accordion className="collapse-full" >
                <Panel header={"Financeiro"} key={"permissoes-financeiro"}>
                    <table className="permission-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ background: "#f5f5f5" }}>
                                <th style={{ textAlign: "left", padding: "8px 12px" }}></th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Selecionar Todos</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Visualizar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Cadastrar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Editar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Excluir</th>
                            </tr>
                        </thead>
                        <tbody>
                            {groupsPayment.map((g) => (
                                <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                    <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                    {renderCell(g.key, "selecionarTodos")}
                                    {renderCell(g.key, "isView")}
                                    {renderCell(g.key, "isCreate")}
                                    {renderCell(g.key, "isEdit")}
                                    {renderCell(g.key, "isDelete")}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Panel>
            </Collapse>

            <Collapse accordion className="collapse-full" >
                <Panel header={"Parâmetros"} key={"permissoes-parametro"}>
                    <table className="permission-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ background: "#f5f5f5" }}>
                                <th style={{ textAlign: "left", padding: "8px 12px" }}></th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Selecionar Todos</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Visualizar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Cadastrar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Editar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Excluir</th>
                            </tr>
                        </thead>
                        <tbody>
                            {groupsParameters.map((g) => (
                                <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                    <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                    {renderCell(g.key, "selecionarTodos")}
                                    {renderCell(g.key, "isView")}
                                    {renderCell(g.key, "isCreate")}
                                    {renderCell(g.key, "isEdit")}
                                    {renderCell(g.key, "isDelete")}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Panel>
            </Collapse>

            <Collapse accordion className="collapse-full" >
                <Panel header={"Acompanhamento"} key={"permissoes-acompanhamento"}>
                    <table className="permission-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ background: "#f5f5f5" }}>
                                <th style={{ textAlign: "left", padding: "8px 12px" }}></th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Selecionar Todos</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Visualizar</th>
                                {/* <th style={{ textAlign: "center", padding: "8px 12px" }}>Cadastrar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Editar</th>
                                <th style={{ textAlign: "center", padding: "8px 12px" }}>Excluir</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {groupsAcomp.map((g) => (
                                <tr key={g.key} style={{ borderBottom: "1px solid #eee" }}>
                                    <td style={{ padding: "8px 12px", width: "280px" }}>{g.label}</td>
                                    {renderCell(g.key, "selecionarTodos")}
                                    {renderCell(g.key, "isView")}
                                    {/* {renderCell(g.key, "isCreate")}
                                    {renderCell(g.key, "isEdit")}
                                    {renderCell(g.key, "isDelete")} */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Panel>
            </Collapse>
        </div>
    );

}